export const GET_DAYWISE_ANALYSIS = 'GET_DAYWISE_ANALYSIS'
export const GET_DAYWISE_ANALYSIS_SEARCH = 'GET_DAYWISE_ANALYSIS_SEARCH'

export const GET_CONSOLIDATED_DAYWISE_ANALYSIS = 'GET_CONSOLIDATED_DAYWISE_ANALYSIS'
export const GET_CONSOLIDATED_DAYWISE_ANALYSIS_SEARCH = 'GET_CONSOLIDATED_DAYWISE_ANALYSIS_SEARCH'

export const GET_TIMEWISE_ANALYSIS = 'GET_TIMEWISE_ANALYSIS'
export const GET_TIMEWISE_ANALYSIS_SEARCH = 'GET_TIMEWISE_ANALYSIS_SEARCH'
export const GET_HOURLY_ANALYSIS = 'GET_HOURLY_ANALYSIS'

export const GET_SHOPWISE_ANALYSIS = 'GET_SHOPWISE_ANALYSIS'
export const GET_MISREPORTED_ANALYSIS = 'GET_MISREPORTED_ANALYSIS'
export const GET_MISREPORTED_INVOICES = 'GET_MISREPORTED_INVOICES'

export const GET_HOURLY_MOBILES = 'GET_HOURLY_MOBILES'

export const GET_CATEGORYWISE_ANALYSIS = 'GET_CATEGORYWISE_ANALYSIS'
export const GET_NEWRETURNING_ANALYSIS = 'GET_NEWRETURNING_ANALYSIS'
export const GET_INCLUSION_ANALYSIS = 'GET_INCLUSION_ANALYSIS'
export const GET_INCLUSION_ANALYSIS_CUS_YEAR = 'GET_INCLUSION_ANALYSIS_CUS_YEAR'
export const GET_INCLUSION_TABLE_DATA = 'GET_INCLUSION_TABLE_DATA'
